/**
 * Pre-checkout size upgrade (safe standalone version)
 *
 * Safety rules:
 * - Standalone overlay only — never uses theme.Popups or the body lock
 * - Intercepts ONLY checkout button clicks inside the cart popup/page
 * - Never listens to form submit, add-to-cart, remove, or quantity events
 * - Recovers page state when restored from bfcache (browser Back from checkout)
 */
(function () {
  'use strict';

  var PRODUCT_CACHE = {};
  var currentOffers = [];
  var isBusy = false;
  var CART_ROOT = '.js-popup-cart-ajax, .js-page-cart-ajax';

  function getConfig() {
    var el = document.getElementById('SizeUpgradeConfig');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getOverlay() {
    return document.getElementById('SizeUpgradeOverlay');
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (Number(cents) / 100).toFixed(2);
    if (!format) return '£' + amount;
    return String(format)
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  }

  /** Parse weight labels like "250g", "1kg", "1.5 kg" into grams. */
  function parseWeightGrams(label) {
    if (!label) return 0;
    var str = String(label).toLowerCase().replace(/\s+/g, '');
    var kg = str.match(/^([\d.]+)kg/);
    if (kg) return Math.round(parseFloat(kg[1]) * 1000);
    var g = str.match(/^([\d.]+)g/);
    if (g) return Math.round(parseFloat(g[1]));
    return 0;
  }

  function pricePerKg(priceCents, grams) {
    if (!grams) return 0;
    return Math.round((priceCents / grams) * 1000);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function fetchProduct(handle) {
    if (PRODUCT_CACHE[handle]) return PRODUCT_CACHE[handle];
    PRODUCT_CACHE[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        delete PRODUCT_CACHE[handle];
        return null;
      });
    return PRODUCT_CACHE[handle];
  }

  function variantOptionLabel(variant) {
    if (variant.options && variant.options.length) {
      return variant.options.join(' / ');
    }
    return variant.title || variant.option1 || '';
  }

  function findUpgradeForLine(item, product) {
    if (!product || !product.variants || product.variants.length < 2) return null;

    var current = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === item.variant_id || product.variants[i].id === item.id) {
        current = product.variants[i];
        break;
      }
    }
    if (!current) return null;

    var currentGrams = parseWeightGrams(variantOptionLabel(current));
    if (!currentGrams) return null;

    var larger = product.variants
      .map(function (v) {
        return { variant: v, grams: parseWeightGrams(variantOptionLabel(v)) };
      })
      .filter(function (entry) {
        return (
          entry.grams > currentGrams &&
          entry.variant.available !== false &&
          entry.variant.id !== current.id
        );
      })
      .sort(function (a, b) {
        return a.grams - b.grams;
      });

    if (!larger.length) return null;

    var next = larger[0];
    var currentPpk = pricePerKg(current.price, currentGrams);
    var nextPpk = pricePerKg(next.variant.price, next.grams);
    var betterValue = nextPpk > 0 && nextPpk < currentPpk;
    var image =
      (next.variant.featured_image && next.variant.featured_image.src) ||
      product.featured_image ||
      item.image ||
      '';

    return {
      key: item.key,
      lineVariantId: item.variant_id || item.id,
      quantity: item.quantity,
      productTitle: product.title || item.product_title,
      image: image,
      handle: product.handle,
      current: {
        id: current.id,
        title: variantOptionLabel(current),
        grams: currentGrams,
        price: current.price,
        pricePerKg: currentPpk
      },
      upgrade: {
        id: next.variant.id,
        title: variantOptionLabel(next.variant),
        grams: next.grams,
        price: next.variant.price,
        pricePerKg: nextPpk
      },
      betterValue: betterValue,
      savingsPercent:
        betterValue && currentPpk > 0
          ? Math.floor(((currentPpk - nextPpk) / currentPpk) * 100)
          : 0
    };
  }

  function buildOffers(cart) {
    var items = (cart && cart.items) || [];
    var handles = [];
    items.forEach(function (item) {
      if (item.handle && handles.indexOf(item.handle) === -1) {
        handles.push(item.handle);
      }
    });

    return Promise.all(handles.map(fetchProduct)).then(function (products) {
      var byHandle = {};
      products.forEach(function (p) {
        if (p && p.handle) byHandle[p.handle] = p;
      });

      var offers = [];
      items.forEach(function (item) {
        var offer = findUpgradeForLine(item, byHandle[item.handle]);
        if (offer) offers.push(offer);
      });
      return offers;
    });
  }

  function thumbUrl(src) {
    if (!src) return '';
    if (src.indexOf('_') !== -1 && /_\d+x/.test(src)) return src;
    return src.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_120x$1$2');
  }

  function renderOffers(offers, config) {
    var container = document.querySelector('[data-size-upgrade-items]');
    if (!container) return;

    container.innerHTML = offers
      .map(function (offer) {
        var img = offer.image
          ? '<img class="popup-size-upgrade__img" src="' +
            thumbUrl(offer.image) +
            '" alt="" width="72" height="72" loading="lazy">'
          : '<span class="popup-size-upgrade__img popup-size-upgrade__img--placeholder"></span>';

        var valueNote = offer.betterValue
          ? '<div class="popup-size-upgrade__value">Better value: ' +
            formatMoney(offer.upgrade.pricePerKg, config.moneyFormat) +
            '/kg <span>(was ' +
            formatMoney(offer.current.pricePerKg, config.moneyFormat) +
            '/kg)</span></div>'
          : '';

        var saveBadge =
          offer.betterValue && offer.savingsPercent >= 5
            ? '<span class="popup-size-upgrade__save-badge">SAVE ' +
              offer.savingsPercent +
              '%</span>'
            : '';

        return (
          '<div class="popup-size-upgrade__item" data-offer-key="' +
          offer.key +
          '">' +
          '<label class="popup-size-upgrade__label">' +
          '<input type="checkbox" class="popup-size-upgrade__check" checked data-offer-toggle>' +
          '<span class="popup-size-upgrade__check-ui" aria-hidden="true"></span>' +
          img +
          '<span class="popup-size-upgrade__details">' +
          '<span class="popup-size-upgrade__name-row">' +
          '<span class="popup-size-upgrade__title">' +
          offer.productTitle +
          '</span>' +
          saveBadge +
          '</span>' +
          '<span class="popup-size-upgrade__sizes">' +
          '<span class="popup-size-upgrade__from">' +
          offer.current.title +
          ' · ' +
          formatMoney(offer.current.price, config.moneyFormat) +
          '</span>' +
          '<span class="popup-size-upgrade__arrow">→</span>' +
          '<span class="popup-size-upgrade__to">' +
          offer.upgrade.title +
          ' · ' +
          formatMoney(offer.upgrade.price, config.moneyFormat) +
          '</span>' +
          '</span>' +
          valueNote +
          '</span>' +
          '</label>' +
          '</div>'
        );
      })
      .join('');
  }

  function selectedOffers() {
    var selected = [];
    var rows = document.querySelectorAll('.popup-size-upgrade__item');
    rows.forEach(function (row, index) {
      var check = row.querySelector('[data-offer-toggle]');
      if (check && check.checked && currentOffers[index]) {
        selected.push(currentOffers[index]);
      }
    });
    return selected;
  }

  /** Batch swap: one update.js call removes all old lines, one add.js adds all upgrades. */
  function swapVariants(offers) {
    if (!offers.length) return Promise.resolve();

    var updates = {};
    offers.forEach(function (offer) {
      updates[offer.key] = 0;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to remove old variants');
        return r.json();
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: offers.map(function (offer) {
              return { id: offer.upgrade.id, quantity: offer.quantity };
            })
          })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to add upgraded variants');
        return r.json();
      });
  }

  /** Close the theme cart popup (also releases its body lock) before showing the offer. */
  function closeThemeCartPopup() {
    try {
      if (window.theme && theme.Popups && typeof theme.Popups.closeByName === 'function') {
        theme.Popups.closeByName('cart');
      }
    } catch (err) {}
  }

  var pageLockedByUs = false;

  /** Freeze the page behind the overlay — no scroll / click-through. */
  function lockPage() {
    if (pageLockedByUs) return;
    try {
      if (window.theme && theme.Global && typeof theme.Global.fixBody === 'function') {
        theme.Global.fixBody();
        pageLockedByUs = true;
        return;
      }
    } catch (err) {}

    var body = document.body;
    var scrollY = window.scrollY || window.pageYOffset || 0;
    body.setAttribute('data-size-upgrade-scroll-y', String(scrollY));
    body.style.top = '-' + scrollY + 'px';
    body.style.position = 'fixed';
    body.style.left = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    pageLockedByUs = true;
  }

  function unlockPage() {
    if (!pageLockedByUs) return;
    pageLockedByUs = false;
    try {
      if (window.theme && theme.Global && typeof theme.Global.unfixBody === 'function') {
        theme.Global.unfixBody();
        return;
      }
    } catch (err) {}

    var body = document.body;
    var scrollY = parseInt(body.getAttribute('data-size-upgrade-scroll-y') || '0', 10) || 0;
    body.removeAttribute('data-size-upgrade-scroll-y');
    body.style.top = '';
    body.style.position = '';
    body.style.left = '';
    body.style.width = '';
    body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function openOverlay() {
    var overlay = getOverlay();
    if (!overlay) return;
    closeThemeCartPopup();
    lockPage();
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    // Let the custom scroll indicator attach now that the list is visible
    try {
      document.dispatchEvent(new CustomEvent('size-upgrade:opened'));
    } catch (err) {}
  }

  function closeOverlay() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('aria-hidden', 'true');
    setBusy(false);
    unlockPage();
  }

  function goToCheckout(config, applyDiscount) {
    closeOverlay();
    // Mark that we're leaving for checkout so a bfcache-restored page
    // (browser Back) can be reloaded cleanly instead of repaired in place.
    try {
      sessionStorage.setItem('sizeUpgradeCheckoutNav', '1');
    } catch (err) {}
    if (applyDiscount && config && config.discountCode) {
      window.location.href =
        '/discount/' +
        encodeURIComponent(config.discountCode) +
        '?redirect=' +
        encodeURIComponent('/checkout');
      return;
    }
    window.location.href = '/checkout';
  }

  function setBusy(busy) {
    isBusy = busy;
    var overlay = getOverlay();
    if (!overlay) return;
    var accept = overlay.querySelector('[data-size-upgrade-accept]');
    var declines = overlay.querySelectorAll('[data-size-upgrade-decline]');
    if (accept) {
      accept.disabled = busy;
      accept.textContent = busy ? 'Updating…' : 'UPGRADE & SAVE NOW →';
    }
    declines.forEach(function (btn) {
      if (btn.tagName === 'BUTTON') btn.disabled = busy;
    });
  }

  function beginUpgradeFlow() {
    var config = getConfig();
    if (!config || !config.enabled || isBusy) return;

    closeThemeCartPopup();
    setBusy(true);
    getCart()
      .then(buildOffers)
      .then(function (offers) {
        setBusy(false);
        if (!offers.length) {
          goToCheckout(config, false);
          return;
        }
        currentOffers = offers;
        renderOffers(offers, config);
        openOverlay();
      })
      .catch(function () {
        setBusy(false);
        goToCheckout(config, false);
      });
  }

  /**
   * Bubble phase only. Matches ONLY checkout buttons inside the cart popup/page.
   * Never matches add-to-cart, remove, quantity arrows, or Continue Shopping.
   */
  function onDocumentClick(e) {
    var config = getConfig();
    if (!config || !config.enabled) return;

    var el = e.target;
    if (!el) return;
    if (el.nodeType !== 1) el = el.parentElement;
    if (!el || typeof el.closest !== 'function') return;

    // Clicks inside our overlay are handled by its own buttons
    if (el.closest('#SizeUpgradeOverlay')) return;

    var btn = el.closest('input[name="checkout"], button[name="checkout"]');
    if (!btn) return;
    if (!btn.closest(CART_ROOT)) return;

    var form = btn.closest('form');
    if (!form || (form.getAttribute('action') || '') !== '/cart') return;

    e.preventDefault();
    if (isBusy) return;
    beginUpgradeFlow();
  }

  function onAccept() {
    if (isBusy) return;
    var config = getConfig();
    var offers = selectedOffers();
    setBusy(true);
    swapVariants(offers)
      .then(function () {
        goToCheckout(config, offers.length > 0);
      })
      .catch(function () {
        goToCheckout(config, false);
      });
  }

  function onDecline(e) {
    if (e) e.preventDefault();
    if (isBusy) return;
    goToCheckout(getConfig(), false);
  }

  function bindOverlayUi() {
    var overlay = getOverlay();
    if (!overlay) return;
    var accept = overlay.querySelector('[data-size-upgrade-accept]');
    if (accept) accept.addEventListener('click', onAccept);
    overlay.querySelectorAll('[data-size-upgrade-decline]').forEach(function (el) {
      el.addEventListener('click', onDecline);
    });

    // The dialog is overflow:hidden — only the offers list should scroll.
    // Focus/anchor scrolling can still silently shift it; snap it back.
    var dialog = overlay.querySelector('.popup-size-upgrade');
    if (dialog) {
      dialog.addEventListener('scroll', function () {
        dialog.scrollTop = 0;
        dialog.scrollLeft = 0;
      });
    }
  }

  /**
   * Recovery after browser Back from checkout (bfcache restore).
   * The theme cart popup may have been open (body locked) when we navigated
   * away, and add-to-cart buttons may be stuck in their disabled state.
   */
  function recoverFromBfcache() {
    closeOverlay();
    pageLockedByUs = false;

    var body = document.body;
    if (body.classList.contains('popup-opened') || body.classList.contains('position-fixed')) {
      try {
        if (window.theme && theme.Popups && typeof theme.Popups.closeAll === 'function') {
          theme.Popups.closeAll();
        }
      } catch (err) {}
      try {
        if (window.theme && theme.Global && typeof theme.Global.unfixBody === 'function') {
          theme.Global.unfixBody();
        }
      } catch (err) {}
      body.classList.remove(
        'popup-opened',
        'position-fixed',
        'left-0',
        'w-100',
        'overflow-hiddenHOLD',
        'offset-scrollHOLD',
        'offset-scroll-padding',
        'fixed-elem'
      );
      body.style.top = '';
      body.style.position = '';
      body.style.left = '';
      body.style.width = '';
      body.style.overflow = '';
      body.removeAttribute('data-size-upgrade-scroll-y');
    }

    // Un-stick add-to-cart / remove buttons left disabled before navigation
    document
      .querySelectorAll(
        '.js-product-button-add-to-cart.active, .js-product-button-remove-from-cart.active'
      )
      .forEach(function (btn) {
        btn.classList.remove('active');
        btn.removeAttribute('disabled');
      });

    // Refresh theme cart data — cart contents changed during the upgrade swap
    try {
      if (window.theme && theme.Cart && typeof theme.Cart.updateData === 'function') {
        theme.Cart.updateData().then(function () {
          if (typeof theme.Cart.updateCart === 'function') {
            return theme.Cart.updateCart();
          }
        });
      }
    } catch (err) {}
  }

  function init() {
    if (!getConfig() || !getOverlay()) return;

    closeOverlay();
    bindOverlayUi();

    // Bubble phase — runs after the theme's own handlers
    document.addEventListener('click', onDocumentClick, false);

    // Only on bfcache restore (browser Back), never on normal page loads
    window.addEventListener('pageshow', function (e) {
      var cameFromCheckout = false;
      try {
        cameFromCheckout = sessionStorage.getItem('sizeUpgradeCheckoutNav') === '1';
        sessionStorage.removeItem('sizeUpgradeCheckoutNav');
      } catch (err) {}

      if (!e.persisted) return;

      if (cameFromCheckout) {
        // Restored frozen page state after our checkout navigation —
        // a full reload is the only reliable way back to a clean page.
        window.location.reload();
        return;
      }

      recoverFromBfcache();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
